import { SET_ACTIVE_TAB } from "../Constants/tabConstants";

export const setActiveTab = (tabKey) => {
  return {
    type: SET_ACTIVE_TAB,
    payload: tabKey,
  };
};
